import { graphql } from '@/gql';

graphql(`
  fragment ScheduledDeliveriesSimpleFragment on PaginatedDeliveryOrderResponse {
    count
    rows {
      id
      callerId
      caller {
        firstName
        lastName
        phoneNumber
        isRequiredMonitoringGourmetOrder
      }
      orderId
      preferredPhoneNumber
      isRedelivery
      originalOrderId
      natureOfComplaint
      clientName
      operatorId
      operator {
        firstName
        lastName
      }
      total
      service
      serviceAccount {
        email
        password
        phoneNumber
      }
      storeOrder {
        title
        subtitle
        phoneNumber
        address {
          formattedAddress
        }
        estimate {
          total
          serviceEstimateReference
          charges {
            title
            value
            originalValue
            tooltips {
              title
              value
            }
          }
          timeEstimate {
            min
            max
          }
          address {
            formattedAddress
            streetAddress2
          }
          promotion {
            promotionUuid
            text
            description
          }
          orderOptions {
            storeInstructions
            deliveryInstructions
            dropoffOptionId
          }
        }
      }
      orderStatus {
        currentProgress
        title
        subtitle
        description
        agent {
          phoneNumber
          name
        }
        locationMarkers {
          title
          latitude
          longitude
        }
      }
      status
      paidStatus
      relatedPath {
        orderResolution {
          resolvedByOrderID
          resolvedOrderID
          redeliveryByOrderId
          resolvedWithoutReorder
        }
      }
      isConfirmedMonitoringCall
      orderCharge {
        total
        card {
          total
          complete
        }
        credits {
          total
          complete
        }
        expiringCredits {
          expiringCreditId
          complete
          total
        }
      }
      schedule {
        id
        day0
        day1
        day2
        day3
        day4
        day5
        day6
        deliveryDate
        deliveryTime
        endAfterXTimes
        endOn
        endOnType
        isRepeated
        dateTimes
        minutesToAutoRetryRequest
        minutesBeforeCustomReminder
        skipDates
        completedAt
        canceledAt
      }
      createdAt
      updatedAt
    }
  }
`);
